<template>
  <el-button
    :id="itemId"
    :data-test="testId"
    :disabled="disabled"
    :type="type"
    class="!py-3 is-dark-green"
    @click="$emit('clicked')"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  props: {
    itemId: {
      type: String,
      default: '',
    },
    testId: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
